/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsBankDetails204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsBankDetails505Schema = z.any();

export const optionsBankDetailsMutationResponseSchema = z.lazy(() => optionsBankDetails204Schema);
